import React from "react";

function ArrowRightIcon() {
  return (
    <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Atoms/Slider" transform="translate(-193.000000, -1.000000)">
          <g id="arrow_right" transform="translate(193.000000, 1.000000)">
            <g id="Group-2" stroke="#000000" strokeWidth="2">
              <circle id="Oval" cx="20" cy="20" r="19"></circle>
            </g>
            <path
              d="M22.3384436,16.2899133 L26.9957576,23.4550116 C27.2967463,23.9180713 27.1653619,24.5374549 26.7023023,24.8384436 C26.540092,24.9438803 26.3507799,25 26.157314,25 L16.842686,25 C16.2904013,25 15.842686,24.5522847 15.842686,24 C15.842686,23.8065341 15.8988058,23.6172219 16.0042424,23.4550116 L20.6615564,16.2899133 C20.9625451,15.8268536 21.5819287,15.6954692 22.0449884,15.996458 C22.1622516,16.0726791 22.2622225,16.17265 22.3384436,16.2899133 Z"
              id="Triangle-Copy"
              fill="#000000"
              transform="translate(21.500000, 20.000000) rotate(-270.000000) translate(-21.500000, -20.000000) "
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ArrowRightIcon;
